import { GET_LOCAL_SETTINGS_TABLE, SET_LOCAL_SETTINGS_TABLE } from 'fixtures/actions'

const initialState = { sizePerPage: {}, filter: {} };

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCAL_SETTINGS_TABLE:
      return { ...action.payload };
    case GET_LOCAL_SETTINGS_TABLE:
      if (action.payload) {
        return { ...action.payload };
      } else {
        return { ...initialState };
      }
    default:
      return state;
  }
}